export default "__VITE_ASSET__DDQCfNtY__"